// extracted by mini-css-extract-plugin
export default {"hero2":"aboutus_hero2__xlbeG"};